<template>
  <EditForm :group="group" :editing="true"/>
</template>

<script>
import EditForm from '@/pages/admin/group/EditForm'
import GroupService from '@/services/GroupService'

export default {
  props: {
    id: String
  },
  components: {EditForm},
  data: () => ({
    group: GroupService.getDefaultItem(),
    groupService: undefined
  }),
  computed: {},
  created () {
    this.groupService = new GroupService(this.$store)
    this.groupService.getItem(this.id, (data) => {
      this.group = data.item
      if (!this.groupService.isEditable(this.group.attestationInfo.status)) {
        this.$router.back()
      }
    })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/group/Edit.vue